const defaultTextValues = {
  buttonSecondary: {
    en: 'Sign In'
  },
  buttonPrimary: {
    en: 'Register'
  },
};

export default defaultTextValues;



